























































import Vue from 'vue';
import * as enteSanitarioApi from '../services/ente-sanitario-api';
import { EnteSanitarioList, EnteSanitarioListViewModel } from '../types';

export default Vue.extend({
    data(): EnteSanitarioListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.ente-sanitario'),
                    value: 'displayName',
                },
                {
                    text: this.$i18n.t('labels.attivo'),
                    value: 'attivo',
                },
            ],
            dataItems: [],
            search: '',
            selectedItems: [],
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await enteSanitarioApi.getList();
        },
        showDetail(item: EnteSanitarioList) {
            this.$router.push({
                name: 'EnteSanitarioDetail',
                params: { id: item.id.toString() },
            });
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await enteSanitarioApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
    },
    mounted() {
        this.loadData();
    },
    watch: {
        $route: {
            handler: async function () {
                await this.loadData();
            },
            deep: true,
        },
    },
});
